import { useSelector } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import {
  GeneralExternalLinkModelTypes,
  selectFromResult,
  useGetGeneralExternalLinksByStockQuery,
} from '@api/general-external-links'
import {
  selectFromResult as selectFromInteractivePlanResult,
  useGetInteractivePlanQuery,
} from '@api/interactive-plan'

import { ProjectType } from '@adUtilities/constants/common'

const useGetGeneralExternalLinks = () => {
  const {
    projectIdentity: { projectName, type: projectType },
    precinctList,
    activeBlock,
    activeLevel,
    activePrecinct,
    activeStage,
  } = useSelector((state: RootStateTypeExtra) => ({
    projectIdentity: state.projectIdentity,
    precinctList: state.houseAndLand.precinctList,
    activeBlock: state.firestore?.session?.building?.activeBlock || '',
    activeLevel: state.firestore?.session?.building?.activeLevel || '',
    activePrecinct:
      state.firestore?.session?.houseAndLand?.activePrecinctId || '',
    activeStage: state.firestore?.session?.houseAndLand?.activeStageId || '',
  }))

  const modelType =
    projectType === ProjectType.HouseAndLand
      ? GeneralExternalLinkModelTypes.STAGE
      : GeneralExternalLinkModelTypes.FLOORPLAN

  const { maps } = useGetInteractivePlanQuery(
    { projectName },
    {
      selectFromResult: selectFromInteractivePlanResult,
      skip: projectType === ProjectType.HouseAndLand,
    }
  )

  const getActiveBlock = () => {
    if (
      maps.blocks &&
      Object.keys(maps.blocks).length > 1 &&
      projectType === ProjectType.Apartment
    ) {
      return { block: activeBlock }
    }
    return undefined
  }

  const getActivePrecinct = () => {
    if (precinctList.length > 1 && projectType === ProjectType.HouseAndLand) {
      return { precinct: activePrecinct }
    }
    return undefined
  }

  const {
    isLoaded,
    isError,
    isFetching,
    generalExternalLinks: fetchedGeneralExternalLinks,
  } = useGetGeneralExternalLinksByStockQuery(
    {
      projectName,
      modelType,
      label: activeLevel || activeStage,
      ...getActiveBlock(),
      ...getActivePrecinct(),
    },
    { selectFromResult }
  )

  if (isFetching) {
    return {
      generalExternalLink: null,
      isLoaded: false,
      isFetching: true,
      isError: false,
    }
  }

  return {
    generalExternalLink: fetchedGeneralExternalLinks?.[0] || null,
    isLoaded,
    isFetching,
    isError,
  }
}

export default useGetGeneralExternalLinks
